<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SponsorHomePage',
  props: {},
  components: {},
  data: () => ({}),
  computed: {},
  methods: {}
}
</script>

<style lang="scss">
// @import 'path/_variables';
</style>
